import axios from 'axios';
import { setupApiInterceptors } from './setupApiInterceptors';

export const identityBaseURL = import.meta.env.VITE_AUTH;

const identityApiInstance = axios.create({
  baseURL: identityBaseURL,
});

export const identityApi = setupApiInterceptors(identityApiInstance);
